<div class="picker-visibility">
  <div class="common-dropdown-list__overlay-header-search-container">
    <div class="common-search__container-tonal">
      <div class="common-search__container-input-text">
        <input type="search"
          class="common-search__input-text"
          [(ngModel)]="pickerVisibility.findDropdown"
          placeholder="{{'common.search-item' | afTranslate}}">
      </div>
      <div class="common-search__block-button-search">
        @if(pickerVisibility.findDropdown){
          <button class="common-button__icon-xs-noborder"
            (click)="resetFilter()">
            <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        }
        <div class="h-[22px]"
            ngClass="{{pickerVisibility.findDropdown?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
        <i class="lf-icon-search common-icon__md"
            ngClass="{{!pickerVisibility.findDropdown?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
      </div>
    </div>
  </div>
  @if (pickerVisibility.filteredItems?.length) {
    <div class="picker-visibility__table-container">
      <div class="picker-visibility__table-header-container">
        <div class="common-table-cell__container w-[60px]">
          <span-tooltip class="common-table-cell__title-text-label"
            [text]="'picker-visibility.include-column' | afTranslate"></span-tooltip>
        </div>
        <div class="common-table-cell__container flex-[1_0_0]">
          <filter-by-search-and-order
            [item]="pickerVisibility.fieldFilter"
            [filterOrder]="pickerVisibility.filterOrder"
            [order]="pickerVisibility.order"
            [typeOverlay]="'overlayInner'"
            (launchActionFilterOrderEmit)="filterOrder($event, 'fieldLabel')">
          </filter-by-search-and-order>
        </div>
        <div class="common-table-cell__container w-[160px]">
          <span-tooltip class="common-table-cell__title-text-label"
            [text]="'common.value' | afTranslate"></span-tooltip>
        </div>
        <div class="common-table-cell__container w-[30px]">
        </div>
      </div>
      <div class="common-table-body__container max-h-[460px]">
        @for (item of pickerVisibility.filteredItems | byWord:pickerVisibility.findDropdown:['fieldLabel', 'valueText'] | afOrderBy:pickerVisibility.filterOrder:pickerVisibility.order; track $index) {
          <div class="picker-visibility__container-row-table"
            [ngClass]="{'picker-visibility__container-row-table--additional-config': item.showAdditionalConfig}">
            <div class="picker-visibility__row-table">
              <div class="common-table-cell__container w-[60px]">
                <field-type-switch
                  [field]="{id: item.key}"
                  [small]="true"
                  [preSelectItem]="item.selected"
                  (itemSelected)="toggleItem($event, item)">
                </field-type-switch>
              </div>
              <div class="picker-visibility__field-container w-[calc(100%-252px)]">
                <span-tooltip
                  class="picker-visibility__field-name"
                  [text]="item.fieldLabel">
                </span-tooltip>
                <span-tooltip
                  class="picker-visibility__field-group"
                  [text]="item.parentContainer ? (item.parentContainer + ' > ' + item.container) : item.container">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[160px]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="item.valueText">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[30px]">
                @if(item.configurable && !item.showAdditionalConfig){
                  <button class="common-button__icon-set-xs"
                    [disabled]="!item.condition?.operator1"
                    [pTooltip]="'common.edit' | afTranslate"
                    [tooltipDisabled]="!item.condition?.operator1"
                    [tooltipPosition]="'top'"
                    (click)="configureItem(item)">
                    <i class="lf-icon-configuration common-icon__md"></i>
                  </button>
                }
              </div>
            </div>
            @if(item.showAdditionalConfig){
              <div class="picker-visibility__additional-config">
                <div class="picker-visibility__operators-container">
                  <div class="common-text-input__field-container-different-values">
                    <div class="common-customize-values__block"
                      [ngClass]="{'common-customize-values__block--error': item?.condition?.operator1Error}">
                      @for (operator of pickerVisibility.operators; track $index) {
                        <button class="common-button__value-formu"
                          [ngClass]="{'common-button__value-formu--selected': operator.listValueId === item?.condition?.operator1}"
                          (click)="operatorSelected(operator, 'operator1', item)">{{operator.text}}</button>
                        @if(!$last){
                          <div class="common-divider__vertical-grey-400 h-[14px]"></div>
                        }
                      }
                    </div>
                    @if(item?.condition?.operator1Error){
                      <div class="common-text-input__mandatory-tag"
                        [afTranslate]="'customize-field.error-configuration'">
                      </div>
                    }
                  </div>
                  <div class="common-text-input__block-number">
                    <div class="common-text-input__block-number">
                      <label class="common-text-input__block-field-input"
                        for="pv-input-value1-visibility"
                        [ngClass]="{'common-text-input__block-field-input--with-value': item?.condition?.value1,
                          'common-text-input__block-field-input--error': item?.condition?.value1Error }"
                        [attr.disabled]="item.dataType === 'text' || !item?.condition?.operator1?true:null">
                        <p-inputNumber class="common-text-input__container-input"
                          styleClass="common-text-input__input-number"
                          [inputId]="'pv-input-value1-visibility'"
                          mode="decimal"
                          [placeholder]="(item.dataType === 'text'?'common.empty':'common.value') | afTranslate"
                          [useGrouping]="false"
                          [min]="0"
                          [disabled]="item.dataType === 'text' || !item?.condition?.operator1"
                          [(ngModel)]="item.condition.value1"
                          (onBlur)="operatorConditionValue('value1', item)"></p-inputNumber>
                      </label>
                    </div>
                    @if(item?.condition?.value1Error){
                      <div class="common-text-input__mandatory-tag"
                        [afTranslate]="'common.error'">
                      </div>
                    }
                  </div>
                  @if(item.dataType !== 'text'){
                    <div class="common-customize-values__block"
                      [attr.disabled]="!item?.condition?.value1 || item?.condition?.operator1 === '=' || item?.condition?.operator1 === '<>'?true:null">
                      @for (operator of pickerVisibility.secondOperator; track $index) {
                        <button class="common-button__value-formu"
                          [ngClass]="{'common-button__value-formu--selected': operator.listValueId === item?.condition?.operator2}"
                          [disabled]="!item?.condition?.value1 || item?.condition?.operator1 === '=' || item?.condition?.operator1 === '<>'"
                          (click)="operatorSelected(operator, 'operator2', item)">{{operator.text}}</button>
                        @if(!$last){
                          <div class="common-divider__vertical-grey-400 h-[14px]"></div>
                        }
                      }
                    </div>
                    <div class="common-text-input__block-number">
                      <div class="common-text-input__block-number">
                        <label class="common-text-input__block-field-input"
                          for="pv-input-value2-visibility"
                          [ngClass]="{'common-text-input__block-field-input--with-value': item?.condition?.value2,
                            'common-text-input__block-field-input--error': item?.condition?.value2Error }"
                          [attr.disabled]="!item?.condition?.operator2?true:null">
                          <p-inputNumber class="common-text-input__container-input"
                            styleClass="common-text-input__input-number"
                            [inputId]="'pv-input-value2-visibility'"
                            mode="decimal"
                            [placeholder]="'common.value' | afTranslate"
                            [useGrouping]="false"
                            [min]="0"
                            [disabled]="!item?.condition?.operator2"
                            [(ngModel)]="item.condition.value2"
                            (onBlur)="operatorConditionValue('value2', item)"></p-inputNumber>
                        </label>
                      </div>
                      @if(item?.condition?.value2Error){
                        <div class="common-text-input__mandatory-tag"
                          [afTranslate]="'common.error'">
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="picker-visibility__operators-buttons-container">
                  <button class="common-button__icon-md-noborder"
                    (click)="checkEditingItem(item)">
                    <i class="lf-icon-check common-icon__md"></i>
                  </button>
                  @if(item.changeConfig){
                    <button class="common-button__icon-md-noborder"
                      (click)="cancelAdditionalConfig(item)">
                      <i class="lf-icon-close common-icon__md"></i>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!pickerVisibility.filteredItems?.length) {
    <div class="picker-visibility__empty-container">
      <span
        class="common-empty-state__message-container"
        [afTranslate]="'picker-visibility.empty-list' | afTranslate">
        _No hay elementos válidos para establecer condiciones
      </span>
    </div>
  }
  @if (pickerVisibility.filteredItems?.length) {
    <div class="picker-visibility__footer-container">
      <div class="picker-visibility__info-footer">
        <span [afTranslate]="'picker-visibility.condition-advise-1'">Indica si las condiciones de visibilidad seleccionadas son de tipo AND (todas las condiciones marcadas tienen que ser ciertas) o de tipo OR (basta con que una de las alternativas sea cierta).</span>
        <span [afTranslate]="'picker-visibility.condition-advise-2'">El valor por defecto será AND.</span>
      </div>
      <div class="common-button__body-decision-button">
        <button class="common-button__decision-button"
            [ngClass]="{'common-button__decision-button--selected': !orCondition}"
            (click)="changeOrCondition(false)">
            <span class="common-button__decision-button-label-text">And</span>
        </button>
        <button class="common-button__decision-button"
            [ngClass]="{'common-button__decision-button--selected': orCondition}"
            (click)="changeOrCondition(true)">
            <span class="common-button__decision-button-label-text">Or</span>
        </button>
      </div>
    </div>
  }
</div>
